"use client";
import t from "react";
import "./index.es16.js";
import "./index.es17.js";
import "./index.es18.js";
import "./index.es19.js";
import "./index.es20.js";
import "./index.es21.js";
import "./index.es22.js";
import "./index.es23.js";
import n from "./index.es24.js";
import "./index.es25.js";
import "./index.es26.js";
import "./index.es27.js";
import "./index.es28.js";
import "./index.es29.js";
import "./index.es30.js";
import "./index.es31.js";
import "./index.es32.js";
import "./index.es33.js";
import "./index.es34.js";
import "./index.es35.js";
import "./index.es36.js";
import "./index.es37.js";
import "./index.es38.js";
import a from "./index.es39.js";
import c from "./index.es40.js";
import s from "./index.es6.js";
const p = ({ component: e }) => e.type === "statistics.statistics-block" ? /* @__PURE__ */ t.createElement("div", { className: "bl-container bl-container--medium bl-p-b-3" }, /* @__PURE__ */ t.createElement(s, { ...e })) : e.type === "statistics.info-block" ? /* @__PURE__ */ t.createElement("div", { className: "bl-container bl-container--small bl-p-b-3" }, /* @__PURE__ */ t.createElement(c, { ...e })) : e.type === "statistics.accordions-block" ? /* @__PURE__ */ t.createElement("div", { className: "bl-container bl-container--small bl-p-b-3" }, /* @__PURE__ */ t.createElement(a, { ...e })) : /* @__PURE__ */ t.createElement(t.Fragment, null), b = ({ components: e, keyContext: o }) => /* @__PURE__ */ t.createElement(t.Fragment, null, e?.map((r) => /* @__PURE__ */ t.createElement("div", { key: `${o}-component-${r.type}-${r.id}` }, /* @__PURE__ */ t.createElement(p, { component: r })))), J = ({
  displayTitle: e,
  introduction: o,
  components: r,
  id: i
}) => {
  const m = o?.content || "", l = o?.tooltips || [];
  return /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement(
    "div",
    {
      id: `section-${i}`,
      className: "bl-container bl-container--small bl-p-t-5"
    },
    !!e && /* @__PURE__ */ t.createElement("h2", { className: "bl-size-2 bl-p-b-3" }, e),
    /* @__PURE__ */ t.createElement(
      n,
      {
        keyContext: `section-ingress-${i}`,
        className: "bl-p-b-3",
        content: m,
        tooltips: l
      }
    )
  ), /* @__PURE__ */ t.createElement(b, { keyContext: `section-${i}`, components: r }));
};
export {
  J as default
};
//# sourceMappingURL=index.es5.js.map
